import { HelpYouSell } from 'shared/landingSeller/components/HelpYouSell';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';

export const HelpYouSellContainer: React.FC = () => {
  const { handleOpenModal, device } = useWithModalForm();

  return <HelpYouSell onOpenModal={handleOpenModal} device={device} />;
};
